import { render, staticRenderFns } from "./EnvelopesEdit.vue?vue&type=template&id=7e3e47f6&"
import script from "./EnvelopesEdit.vue?vue&type=script&lang=js&"
export * from "./EnvelopesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EnvelopesEdit.vue"
export default component.exports